import { DependencyList } from 'react'
import { useKey } from 'react-use'

export const useNavItemSubmit = (callbackFn: () => void, isEnabled = true, dependencyList?: DependencyList) => {
  const target = isEnabled ? window : null

  useKey('Enter', callbackFn, { target }, [...(dependencyList || []), target])
  useKey('Tab', callbackFn, { target }, [...(dependencyList || []), target])
}
